import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import Card from 'tio-ui/components/card';
import Chip from 'tio-ui/components/chip';

interface DashboardTileSignature {
  Args: {
    headerText?: string;
    isUrgent?: boolean;
    showAdminBadge?: boolean;
  };
  Blocks: {
    body: [];
    description: [];
    footer: [];
    header: [];
    image: [];
  };
}

const DashboardTileComponent: TOC<DashboardTileSignature> = <template>
  <Card
    @padding="none"
    @elevation="card"
    @radius="card"
    class="tio-col-flush tio-elevation-card-hover overflow-hidden aspect-square w-full h-full relative"
  >
    <div
      class="border-b tio-border-subtle px-4 sm:px-2 py-1.5 min-h-10 gap-x-2 tio-row-between flex-row flex-wrap text-base md:text-base"
      data-test-dashboard-tile-header
    >
      {{#if (has-block "header")}}
        {{yield to="header"}}
      {{else}}
        <h3 class="tio-text-sm-semibold" data-test-dashboard-tile-title>{{@headerText}}</h3>
        {{#if @isUrgent}}
          <span class="font-semibold tio-fg-danger" data-test-dashboard-tile-urgent-label>
            {{t "dashboard_tiles.to_do_now"}}
          </span>
        {{/if}}
        {{#if @showAdminBadge}}
          <Chip @intent="primary">
            {{t "dashboard_tiles.admin"}}
          </Chip>
        {{/if}}
      {{/if}}
    </div>
    <div
      class="tio-col-flush p-4 sm:p-2 xl:p-4 w-full flex-1 min-h-0 overflow-hidden tio-fg-primary text-base md:text-sm xl:text-base"
    >
      {{#if (has-block "body")}}
        {{yield to="body"}}
      {{else}}
        <div class="mb-2">{{yield to="description"}}</div>
        <div class="tio-row-center grow overflow-hidden">
          {{yield to="image"}}
        </div>
      {{/if}}
    </div>
    {{#if (has-block "footer")}}
      <div class="absolute bottom-0 right-0">
        {{yield to="footer"}}
      </div>
    {{/if}}
  </Card>
</template>;

export default DashboardTileComponent;
